<template>
  <div class="flexSpaceBetweenRow" style="padding: 10px">
    <div class="flexLeftRow">
      <GripVertical size="15" color="#808080" class="vgrip" />
      <h3 style="margin-left: 10px">{{ this.title }}</h3>
    </div>
    <!-- <Ellipsis size="15" color="#808080" /> -->
    <BaseButton :icon="RotateCw" @click="reload()" />
  </div>
  <component
    :is="this.chartType"
    :text="'hello world'"
    :data="this.data"
    style="width: 100%"
  />
  <!-- <BarChart /> -->
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";
import { GripVertical, Ellipsis, RotateCw } from "lucide-vue-next";
import BaseButton from "../buttons/BaseButton.vue";
import BarChart from "./BarChart.vue";
import LineChart from "./LineChart.vue";
import MapChart from "./MapChart.vue";
import PieChart from "./PieChart.vue";

export default {
  name: "Chart",
  components: {
    BaseButton,
    GripVertical,
    Ellipsis,
    BarChart,
    LineChart,
    MapChart,
    PieChart,
  },
  props: {
    chartType: {
      type: String,
      default: "BarChart",
    },
    title: {
      type: String,
      default: "hello world",
    },
    data: Object,
  },
  methods: {
    reload() {
      this.$emit("reload");
    },
  },
  setup() {
    return {};
  },
  data() {
    return {
      RotateCw,
    };
  },
};
</script>

<style>
.vgrip {
  cursor: grab;
}
.vgrip:active {
  cursor: grabbing;
}
</style>
